export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'campus', name: '校园', icon: 'ri-school-line' },
  { slug: 'office', name: '职场', icon: 'ri-briefcase-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'historical', name: '古风', icon: 'ri-ancient-gate-line' },
  { slug: 'modern', name: '现代', icon: 'ri-building-line' },
  { slug: 'mature', name: '成熟', icon: 'ri-user-heart-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
  { slug: 'romance', name: '纯爱', icon: 'ri-heart-line' },
];

export const comics = [
  {
    id: 'comic-001',
    title: '深渊之歌',
    author: '金秀贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20BL%20manhwa%20cover%20art%20style%2C%20two%20beautiful%20young%20men%20in%20romantic%20embrace%2C%20dark%20fantasy%20theme%20with%20soft%20lighting%2C%20delicate%20line%20art%2C%20muted%20warm%20tones%2C%20emotional%20atmosphere%2C%20clean%20illustration%20style%20on%20plain%20background&width=600&height=800&seq=manga-cover-001&orientation=portrait',
    description: '在深渊的边缘，两个灵魂相遇。一个是身负诅咒的贵族之子，一个是来自深渊的神秘少年。他们之间的命运纠缠，将揭开隐藏在王国深处的惊天秘密。一段跨越种族与阶级的禁忌之恋，在黑暗与光明之间悄然绽放。',
    categories: ['fantasy', 'drama', 'romance'],
    status: 'ongoing' as const,
    chapters: [
      { id: 'ch-001-1', number: 1, title: '命运的相遇', createdAt: '2026-07-28' },
      { id: 'ch-001-2', number: 2, title: '深渊的低语', createdAt: '2026-07-25' },
      { id: 'ch-001-3', number: 3, title: '禁忌之吻', createdAt: '2026-07-22' },
      { id: 'ch-001-4', number: 4, title: '黑暗中的光', createdAt: '2026-07-18' },
      { id: 'ch-001-5', number: 5, title: '誓约', createdAt: '2026-07-14' },
      { id: 'ch-001-6', number: 6, title: '秘密花园', createdAt: '2026-07-10' },
      { id: 'ch-001-7', number: 7, title: '风暴前夕', createdAt: '2026-07-06' },
      { id: 'ch-001-8', number: 8, title: '觉醒', createdAt: '2026-07-02' },
    ],
    rating: 4.8,
    views: 1285000,
    updatedAt: '2026-08-04',
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-002',
    title: '那年夏天的风',
    author: '李智恩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20BL%20manhwa%20cover%2C%20two%20high%20school%20boys%20in%20school%20uniform%20walking%20together%20under%20cherry%20blossoms%2C%20youthful%20summer%20vibe%2C%20soft%20pastel%20warm%20colors%2C%20gentle%20romantic%20atmosphere%2C%20clean%20illustration%20on%20plain%20background&width=600&height=800&seq=manga-cover-002&orientation=portrait',
    description: '转学到海边小镇的高中生林在宇，遇见了性格截然相反的班长韩夏天。一个安静内敛，一个阳光开朗。在盛夏的海风中，两颗年轻的心慢慢靠近，谱写出一段青涩而美好的校园恋曲。',
    categories: ['campus', 'romance', 'comedy'],
    status: 'completed' as const,
    chapters: [
      { id: 'ch-002-1', number: 1, title: '转学生', createdAt: '2026-06-15' },
      { id: 'ch-002-2', number: 2, title: '海边的约定', createdAt: '2026-06-12' },
      { id: 'ch-002-3', number: 3, title: '心跳加速', createdAt: '2026-06-08' },
      { id: 'ch-002-4', number: 4, title: '烟花大会', createdAt: '2026-06-04' },
      { id: 'ch-002-5', number: 5, title: '告白', createdAt: '2026-05-30' },
      { id: 'ch-002-6', number: 6, title: '永远的夏天', createdAt: '2026-05-26' },
    ],
    rating: 4.9,
    views: 2350000,
    updatedAt: '2026-06-15',
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-003',
    title: '办公室密语',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20BL%20manhwa%20cover%2C%20two%20handsome%20men%20in%20formal%20suits%20in%20modern%20office%20setting%2C%20professional%20atmosphere%20with%20subtle%20romantic%20tension%2C%20warm%20muted%20color%20palette%2C%20clean%20illustration%20style%20on%20plain%20background&width=600&height=800&seq=manga-cover-003&orientation=portrait',
    description: '新入职的职场菜鸟姜珉宇，意外发现顶头上司崔组长就是自己大学时期暗恋过的学长。在繁忙的办公室日常中，隐藏多年的感情重新萌发。面对职场压力与内心情感，两人将如何抉择？',
    categories: ['office', 'modern', 'drama'],
    status: 'ongoing' as const,
    chapters: [
      { id: 'ch-003-1', number: 1, title: '第一天', createdAt: '2026-08-01' },
      { id: 'ch-003-2', number: 2, title: '意外的重逢', createdAt: '2026-07-28' },
      { id: 'ch-003-3', number: 3, title: '加班夜', createdAt: '2026-07-24' },
      { id: 'ch-003-4', number: 4, title: '出差', createdAt: '2026-07-20' },
      { id: 'ch-003-5', number: 5, title: '无法隐藏的心', createdAt: '2026-07-16' },
    ],
    rating: 4.7,
    views: 890000,
    updatedAt: '2026-08-04',
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-004',
    title: '花间醉',
    author: '尹素熙',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20BL%20manhwa%20cover%2C%20two%20beautiful%20men%20in%20traditional%20Korean%20hanbok%20costumes%20in%20ancient%20palace%20garden%2C%20historical%20romance%2C%20soft%20warm%20lighting%2C%20delicate%20line%20art%2C%20elegant%20composition%20on%20plain%20background&width=600&height=800&seq=manga-cover-004&orientation=portrait',
    description: '朝鲜时代，世子李暄与宫廷画师朴延宇之间不被世俗所容的情感。在宫廷权谋与花间醉意中，两人用画笔与真心，描绘出一段超越时代的深情。花开有声，情深无言。',
    categories: ['historical', 'romance', 'drama'],
    status: 'ongoing' as const,
    chapters: [
      { id: 'ch-004-1', number: 1, title: '入宫', createdAt: '2026-07-20' },
      { id: 'ch-004-2', number: 2, title: '第一幅画', createdAt: '2026-07-16' },
      { id: 'ch-004-3', number: 3, title: '月下', createdAt: '2026-07-12' },
      { id: 'ch-004-4', number: 4, title: '花宴', createdAt: '2026-07-08' },
      { id: 'ch-004-5', number: 5, title: '誓言', createdAt: '2026-07-04' },
      { id: 'ch-004-6', number: 6, title: '危机', createdAt: '2026-06-30' },
      { id: 'ch-004-7', number: 7, title: '守护', createdAt: '2026-06-26' },
    ],
    rating: 4.9,
    views: 1890000,
    updatedAt: '2026-08-03',
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-005',
    title: '咖啡与谎言',
    author: '崔恩秀',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20BL%20manhwa%20cover%2C%20two%20young%20men%20in%20cozy%20coffee%20shop%20setting%2C%20warm%20ambient%20lighting%2C%20one%20as%20barista%20and%20one%20as%20customer%2C%20romantic%20modern%20slice%20of%20life%2C%20soft%20warm%20color%20palette%2C%20clean%20illustration&width=600&height=800&seq=manga-cover-005&orientation=portrait',
    description: '咖啡师成宇的咖啡馆里，每天都会来一位神秘客人——他总是点同一杯美式，坐在同一个角落，写下永远不会寄出的信。当成宇意外读到其中一封信时，一段被时光掩埋的秘密悄然浮出水面。',
    categories: ['modern', 'drama', 'mature'],
    status: 'completed' as const,
    chapters: [
      { id: 'ch-005-1', number: 1, title: '陌生人', createdAt: '2026-05-20' },
      { id: 'ch-005-2', number: 2, title: '第一封信', createdAt: '2026-05-16' },
      { id: 'ch-005-3', number: 3, title: '真相', createdAt: '2026-05-12' },
      { id: 'ch-005-4', number: 4, title: '原谅', createdAt: '2026-05-08' },
      { id: 'ch-005-5', number: 5, title: '重新开始', createdAt: '2026-05-04' },
    ],
    rating: 4.6,
    views: 670000,
    updatedAt: '2026-05-20',
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-006',
    title: '星之轨迹',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20BL%20manhwa%20cover%2C%20two%20men%20in%20futuristic%20sci-fi%20setting%20with%20stars%20and%20galaxy%20background%2C%20one%20in%20military%20uniform%20and%20one%20in%20civilian%20clothes%2C%20emotional%20space%20romance%2C%20warm%20cosmic%20color%20tones%2C%20clean%20illustration&width=600&height=800&seq=manga-cover-006&orientation=portrait',
    description: '未来世界，星际飞行员郑宇宙在执行任务时迫降在一颗未知星球。在那里，他遇到了独自生活多年的神秘男子沈星河。在浩瀚星河之间，两个孤独的灵魂找到了彼此的归宿。',
    categories: ['fantasy', 'romance', 'drama'],
    status: 'ongoing' as const,
    chapters: [
      { id: 'ch-006-1', number: 1, title: '迫降', createdAt: '2026-08-02' },
      { id: 'ch-006-2', number: 2, title: '异星来客', createdAt: '2026-07-29' },
      { id: 'ch-006-3', number: 3, title: '星河之下', createdAt: '2026-07-25' },
      { id: 'ch-006-4', number: 4, title: '信号', createdAt: '2026-07-21' },
    ],
    rating: 4.7,
    views: 520000,
    updatedAt: '2026-08-04',
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-007',
    title: '偷偷喜欢你',
    author: '张美英',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20BL%20manhwa%20cover%2C%20two%20cute%20university%20students%20in%20casual%20clothes%20sitting%20on%20campus%20bench%2C%20one%20blushing%2C%20lighthearted%20youth%20romance%2C%20bright%20warm%20color%20palette%2C%20clean%20illustration%20style%20on%20plain%20background&width=600&height=800&seq=manga-cover-007&orientation=portrait',
    description: '大学校园里，内向的美术生小云暗恋着同系的阳光学长陈阳。他偷偷画下学长的每一个瞬间，却没发现自己也成了别人眼中的风景。一场双向暗恋的甜蜜故事。',
    categories: ['campus', 'comedy', 'romance'],
    status: 'ongoing' as const,
    chapters: [
      { id: 'ch-007-1', number: 1, title: '素描本', createdAt: '2026-07-30' },
      { id: 'ch-007-2', number: 2, title: '画室', createdAt: '2026-07-26' },
      { id: 'ch-007-3', number: 3, title: '校园祭', createdAt: '2026-07-22' },
      { id: 'ch-007-4', number: 4, title: '雨天', createdAt: '2026-07-18' },
      { id: 'ch-007-5', number: 5, title: '那个微笑', createdAt: '2026-07-14' },
      { id: 'ch-007-6', number: 6, title: '勇气', createdAt: '2026-07-10' },
    ],
    rating: 4.8,
    views: 1560000,
    updatedAt: '2026-08-04',
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-008',
    title: '禁忌游戏',
    author: '韩智勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20BL%20manhwa%20cover%2C%20two%20mature%20men%20in%20luxurious%20penthouse%20setting%20with%20city%20night%20view%2C%20intense%20eye%20contact%2C%20dark%20and%20sophisticated%20mood%2C%20mature%20romance%20theme%2C%20warm%20dark%20tones%2C%20clean%20illustration&width=600&height=800&seq=manga-cover-008&orientation=portrait',
    description: '财阀继承人权泰浩与地下拳手李赫，两个来自不同世界的人因一场意外相遇。在权力、金钱与欲望的漩涡中，他们开始了一场危险的禁忌游戏。但谁也没想到，最先沦陷的会是自己的心。',
    categories: ['mature', 'drama', 'modern'],
    status: 'ongoing' as const,
    chapters: [
      { id: 'ch-008-1', number: 1, title: '狭路相逢', createdAt: '2026-07-15' },
      { id: 'ch-008-2', number: 2, title: '交易', createdAt: '2026-07-11' },
      { id: 'ch-008-3', number: 3, title: '失控', createdAt: '2026-07-07' },
      { id: 'ch-008-4', number: 4, title: '深渊', createdAt: '2026-07-03' },
    ],
    rating: 4.5,
    views: 980000,
    updatedAt: '2026-08-02',
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-009',
    title: '月光奏鸣曲',
    author: '柳河镇',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20BL%20manhwa%20cover%2C%20two%20men%20playing%20piano%20together%20in%20moonlit%20music%20room%2C%20one%20teacher%20and%20one%20student%2C%20classical%20music%20theme%2C%20elegant%20warm%20atmosphere%2C%20soft%20moonlight%2C%20clean%20illustration%20style&width=600&height=800&seq=manga-cover-009&orientation=portrait',
    description: '天才钢琴家韩瑞安因手伤告别舞台，回到母校成为音乐教师。在那里，他遇到了极具天赋却桀骜不驯的学生金道允。音乐成为两人之间最深的羁绊，一首月光奏鸣曲，奏响了心底最柔软的声音。',
    categories: ['campus', 'drama', 'mature'],
    status: 'ongoing' as const,
    chapters: [
      { id: 'ch-009-1', number: 1, title: '重返', createdAt: '2026-07-22' },
      { id: 'ch-009-2', number: 2, title: '琴键上的对决', createdAt: '2026-07-18' },
      { id: 'ch-009-3', number: 3, title: '合奏', createdAt: '2026-07-14' },
      { id: 'ch-009-4', number: 4, title: '月光', createdAt: '2026-07-10' },
      { id: 'ch-009-5', number: 5, title: '过去的影子', createdAt: '2026-07-06' },
    ],
    rating: 4.8,
    views: 1120000,
    updatedAt: '2026-08-03',
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-010',
    title: '邻家哥哥',
    author: '郑秀雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20BL%20manhwa%20cover%2C%20two%20young%20men%20in%20neighborhood%20setting%2C%20one%20leaning%20on%20balcony%20and%20one%20waving%20from%20below%2C%20slice%20of%20life%20romance%2C%20warm%20sunset%20lighting%2C%20cozy%20atmosphere%2C%20clean%20illustration%20style&width=600&height=800&seq=manga-cover-010&orientation=portrait',
    description: '大学生韩智浩搬进了新的公寓，发现隔壁住着一位温柔体贴的邻家哥哥裴政宇。从借酱油到深夜谈心，日常的点滴相处中，友情悄然转变为更深的情感。',
    categories: ['modern', 'romance', 'comedy'],
    status: 'completed' as const,
    chapters: [
      { id: 'ch-010-1', number: 1, title: '新邻居', createdAt: '2026-04-10' },
      { id: 'ch-010-2', number: 2, title: '借酱油', createdAt: '2026-04-06' },
      { id: 'ch-010-3', number: 3, title: '天台', createdAt: '2026-04-02' },
      { id: 'ch-010-4', number: 4, title: '生病', createdAt: '2026-03-28' },
      { id: 'ch-010-5', number: 5, title: '心意', createdAt: '2026-03-24' },
      { id: 'ch-010-6', number: 6, title: '在一起', createdAt: '2026-03-20' },
    ],
    rating: 4.7,
    views: 1430000,
    updatedAt: '2026-04-10',
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-011',
    title: '失忆之后',
    author: '金宇彬',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20BL%20manhwa%20cover%2C%20man%20waking%20up%20in%20hospital%20bed%20with%20another%20man%20holding%20his%20hand%20worried%2C%20emotional%20drama%20scene%2C%20soft%20warm%20lighting%2C%20medical%20setting%2C%20clean%20illustration%20style%20on%20plain%20background&width=600&height=800&seq=manga-cover-011&orientation=portrait',
    description: '一场车祸让尹在赫失去了过去三年的记忆。醒来后，他发现身边多了一个自称是他恋人的陌生男人——徐正宇。在找回记忆的过程中，过去的真相远比想象的更加复杂。',
    categories: ['drama', 'modern', 'mature'],
    status: 'ongoing' as const,
    chapters: [
      { id: 'ch-011-1', number: 1, title: '空白', createdAt: '2026-07-18' },
      { id: 'ch-011-2', number: 2, title: '陌生人', createdAt: '2026-07-14' },
      { id: 'ch-011-3', number: 3, title: '碎片', createdAt: '2026-07-10' },
      { id: 'ch-011-4', number: 4, title: '谎言', createdAt: '2026-07-06' },
    ],
    rating: 4.6,
    views: 760000,
    updatedAt: '2026-08-01',
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-012',
    title: '龙与玫瑰',
    author: '宋慧乔',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20BL%20manhwa%20cover%2C%20dragon%20shape%20shifter%20and%20human%20man%20in%20fantasy%20medieval%20setting%2C%20magical%20romance%2C%20one%20with%20dragon%20scales%20and%20one%20holding%20rose%2C%20warm%20golden%20and%20rose%20tones%2C%20clean%20illustration&width=600&height=800&seq=manga-cover-012&orientation=portrait',
    description: '龙族最后的血脉金泰亨化为人形，隐藏身份生活在人类王国。他在花园中遇见了一位痴迷玫瑰的贵族少年，两人之间萌生了跨越种族的情感。但龙族的宿命与人类的偏见，将他们的爱情推向了生死考验。',
    categories: ['fantasy', 'romance', 'historical'],
    status: 'ongoing' as const,
    chapters: [
      { id: 'ch-012-1', number: 1, title: '龙之形', createdAt: '2026-07-25' },
      { id: 'ch-012-2', number: 2, title: '玫瑰园的相遇', createdAt: '2026-07-21' },
      { id: 'ch-012-3', number: 3, title: '秘密', createdAt: '2026-07-17' },
      { id: 'ch-012-4', number: 4, title: '追捕', createdAt: '2026-07-13' },
      { id: 'ch-012-5', number: 5, title: '龙之心', createdAt: '2026-07-09' },
      { id: 'ch-012-6', number: 6, title: '守护', createdAt: '2026-07-05' },
    ],
    rating: 4.9,
    views: 2100000,
    updatedAt: '2026-08-04',
    isHot: true,
    isNew: false,
  },
];

export const testimonials = [
  {
    id: 't-1',
    name: '小雨',
    avatar: 'https://readdy.ai/api/search-image?query=soft%20anime%20style%20young%20woman%20portrait%2C%20warm%20smile%2C%20simple%20clean%20background%2C%20illustration&width=100&height=100&seq=avatar-001&orientation=squarish',
    content: '韩漫阅读是我用过最好的耽美漫画平台！更新速度超快，画质清晰，下拉式阅读体验太流畅了。每天必刷，已经推荐给了身边所有同好！',
    rating: 5,
    date: '2026-07-15',
  },
  {
    id: 't-2',
    name: '星辰大海',
    avatar: 'https://readdy.ai/api/search-image?query=soft%20anime%20style%20young%20man%20portrait%2C%20gentle%20expression%2C%20simple%20clean%20background%2C%20illustration&width=100&height=100&seq=avatar-002&orientation=squarish',
    content: '收藏夹里全是韩漫阅读的漫画，分类很细致，找漫画特别方便。而且无删减这一点太重要了，很多平台都有删减，只有这里能看到完整版。',
    rating: 5,
    date: '2026-08-01',
  },
  {
    id: 't-3',
    name: '樱花飘落',
    avatar: 'https://readdy.ai/api/search-image?query=soft%20anime%20style%20young%20woman%20portrait%2C%20cute%20smile%2C%20simple%20clean%20background%2C%20illustration&width=100&height=100&seq=avatar-003&orientation=squarish',
    content: '从三年前就开始在这里看漫画了，见证了这个平台越来越好的过程。漫画种类越来越多，翻译质量也一直很高，真心推荐！',
    rating: 5,
    date: '2026-07-28',
  },
  {
    id: 't-4',
    name: '慕白',
    avatar: 'https://readdy.ai/api/search-image?query=soft%20anime%20style%20mature%20man%20portrait%2C%20warm%20expression%2C%20simple%20clean%20background%2C%20illustration&width=100&height=100&seq=avatar-004&orientation=squarish',
    content: '下拉式阅读模式太方便了！不用频繁翻页，一口气看几十话都不累。而且页面设计简洁好看，没有乱七八糟的广告，沉浸感很棒。',
    rating: 4,
    date: '2026-07-20',
  },
  {
    id: 't-5',
    name: '夜雨声烦',
    avatar: 'https://readdy.ai/api/search-image?query=soft%20anime%20style%20young%20woman%20portrait%2C%20cool%20expression%2C%20simple%20clean%20background%2C%20illustration&width=100&height=100&seq=avatar-005&orientation=squarish',
    content: '被朋友安利过来的，结果一发不可收拾！这里的耽美韩漫真的太全了，很多小众好作品都能找到，简直是宝藏平台。',
    rating: 5,
    date: '2026-08-02',
  },
  {
    id: 't-6',
    name: '清风徐来',
    avatar: 'https://readdy.ai/api/search-image?query=soft%20anime%20style%20young%20man%20portrait%2C%20bright%20smile%2C%20simple%20clean%20background%2C%20illustration&width=100&height=100&seq=avatar-006&orientation=squarish',
    content: '纯爱党狂喜！校园题材的分类做得特别好，每部漫画都有详细的标签和简介，帮助我精准找到想看的类型。已经看了几十部了！',
    rating: 5,
    date: '2026-07-25',
  },
];

export const faqs = [
  {
    question: '韩漫阅读平台上的漫画是否免费？',
    answer: '是的，韩漫阅读平台上的所有漫画均免费提供在线阅读。我们致力于为耽美漫画爱好者提供高质量的免费阅读体验，无需付费即可畅读所有内容。',
  },
  {
    question: '什么是下拉式阅读模式？',
    answer: '下拉式阅读是一种专为手机和网页优化的漫画阅读方式。您只需向下滑动页面，漫画内容会连续不断地呈现，无需手动翻页。这种模式模拟了网页浏览的体验，让阅读更加流畅自然。',
  },
  {
    question: '平台上的漫画是否有删减？',
    answer: '韩漫阅读坚持提供无删减的完整漫画内容。我们尊重原作者的创作，所有漫画均保持原版完整内容，让读者获得最真实的阅读体验。',
  },
  {
    question: '漫画多久更新一次？',
    answer: '我们会根据原作的更新频率同步更新，通常在每部漫画原版更新后的24小时内完成翻译和上传。热门漫画通常每周更新，部分作品可能因作者排期有所不同。',
  },
  {
    question: '如何在手机上获得更好的阅读体验？',
    answer: '韩漫阅读网站采用了响应式设计，在手机浏览器中打开即可自动适配屏幕尺寸。下拉式阅读模式在手机上体验尤其优秀，建议使用Chrome或Safari等现代浏览器访问。',
  },
  {
    question: '如何找到我想看的特定类型漫画？',
    answer: '您可以通过首页的分类导航进入不同题材的漫画列表，包括校园、职场、奇幻、古风、现代等多个分类。也可以使用搜索功能根据漫画名称或作者进行查找。',
  },
];